import React from "react"
import PropTypes from "prop-types"
import MessageListAssistantWrapper from "./MessageListAssistantWrapper"

const MessageListAssistant = props => {
  const { chatRoomId, user } = props

  if (!chatRoomId || user === "") {
    return <div>請選擇使用者</div>
  }

  return <MessageListAssistantWrapper {...props} />
}

MessageListAssistant.propTypes = {
  chatRoomId: PropTypes.string,
  user: PropTypes.string
}

export default MessageListAssistant
